import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

// View
import CreateAttributeDialog from './CreateAttributeDialog';

// Actions
import { toggleCreateAttributeDialog, createCategoryField } from 'store/attribute';
import makeEntityTypesFetch from 'store/configuration/actions/entityTypesFetch';

interface Props {
  onCreate: (newAttribute: any) => void;
}

export default function CreateAttributeDialogContainer(props: Props) {
  const entityTypesFetch = makeEntityTypesFetch();

  const isCreateAttributeDialogOpen = useSelector(
    (state: any) => state.attribute.isCreateAttributeDialogOpen,
  );

  const dispatch = useDispatch();
  const handleToggleCreateAttributeDialog = () => {
    dispatch(toggleCreateAttributeDialog());
  };

  const handleCreateCategoryField = async (newAttribute: any) => {
    const data = await dispatch(createCategoryField(newAttribute));
    await dispatch(entityTypesFetch());
    return data;
  };

  return (
    <CreateAttributeDialog
      {...props}
      isCreateAttributeDialogOpen={isCreateAttributeDialogOpen}
      createCategoryField={handleCreateCategoryField}
      toggleCreateAttributeDialog={handleToggleCreateAttributeDialog}
    />
  );
}
